export const SKELETON_ROW_COUNT = 5
